export const createTemplateRegions = () => {
  return {
    header: { enabled: true, height: 72, elements: [] },
    dataContent: {
      dataSource: '',
      elements: [],
      mode: 'single',
      repeatLayout: {
        columns: 1,
        gap: 12,
        keepTogether: true,
        pageBreak: 'auto',
        rows: 1,
      },
    },
    footer: { enabled: true, height: 48, elements: [] },
  };
};

export const getCanvasMargins = (template) => {
  const margins = template?.canvas?.margins || {};

  return {
    bottom: Math.max(0, Number(margins.bottom) || 0),
    left: Math.max(0, Number(margins.left) || 0),
    right: Math.max(0, Number(margins.right) || 0),
    top: Math.max(0, Number(margins.top) || 0),
  };
};

export const getRegionHeight = (template, regionName) => {
  const region = template?.regions?.[regionName];

  return region?.enabled === false ? 0 : Math.max(0, Number(region?.height) || 0);
};

export const getDataContentElements = (template) => {
  return getRegionElements(template, 'dataContent');
};

export const getRegionElements = (template, regionName) => {
  return template?.regions?.[regionName]?.elements || [];
};

export const getDataContentBounds = (template) => {
  const headerHeight = getRegionHeight(template, 'header');
  const footerHeight = getRegionHeight(template, 'footer');
  const margins = getCanvasMargins(template);

  return {
    height: Math.max(0, template.canvas.height - margins.top - margins.bottom - headerHeight - footerHeight),
    width: Math.max(0, template.canvas.width - margins.left - margins.right),
    x: margins.left,
    y: margins.top + headerHeight,
  };
};

export const getRepeatCardLayout = (template) => {
  const dataContentBounds = getDataContentBounds(template);
  const repeatLayout = template.regions.dataContent.repeatLayout;
  const columns = Math.max(1, Number(repeatLayout.columns) || 1);
  const rows = Math.max(1, Number(repeatLayout.rows) || 1);
  const gap = Math.max(0, Number(repeatLayout.gap) || 0);

  return {
    cardHeight: (dataContentBounds.height - gap * (rows - 1)) / rows,
    cardWidth: (dataContentBounds.width - gap * (columns - 1)) / columns,
    columns,
    gap,
    rows,
    x: dataContentBounds.x,
    y: dataContentBounds.y,
  };
};

// Converts the original one-canvas schema into the three-region schema on load.
export const normalizeTemplate = (template) => {
  const regions = template?.regions || {};
  const defaultRegions = createTemplateRegions();
  const legacyElements = Array.isArray(template?.elements) ? template.elements : [];
  const normalizeElements = (elements) => {
    return elements.map((element) => {
      if (element.type !== 'rectangle' || element.styles?.fill !== '#e8f1fb') {
        return element;
      }

      return {
        ...element,
        styles: {
          ...element.styles,
          fill: 'transparent',
        },
      };
    });
  };
  const dataContentElements = Array.isArray(regions.dataContent?.elements)
    ? normalizeElements(regions.dataContent.elements)
    : normalizeElements(legacyElements);
  const dataSource = regions.dataContent?.dataSource === 'evaluatorSchedules' ? 'evaluators' : regions.dataContent?.dataSource || '';

  return {
    ...template,
    canvas: {
      ...template?.canvas,
      margins: getCanvasMargins(template),
    },
    schemaVersion: Math.max(Number(template?.schemaVersion) || 1, 2),
    regions: {
      header: {
        ...defaultRegions.header,
        ...regions.header,
        elements: Array.isArray(regions.header?.elements) ? normalizeElements(regions.header.elements) : [],
      },
      dataContent: {
        ...defaultRegions.dataContent,
        ...regions.dataContent,
        dataSource,
        elements: dataContentElements,
        repeatLayout: {
          ...defaultRegions.dataContent.repeatLayout,
          ...regions.dataContent?.repeatLayout,
        },
      },
      footer: {
        ...defaultRegions.footer,
        ...regions.footer,
        elements: Array.isArray(regions.footer?.elements) ? normalizeElements(regions.footer.elements) : [],
      },
    },
  };
};
